import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSections() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <div className="space-y-24 py-12 px-6 max-w-3xl mx-auto text-[#3D3631]" data-id="element-96">
      {/* Para quién es esto */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-[#E8DDD0]" data-id="element-97">
        <h2 className="font-serif text-3xl font-bold text-[#2A6B6B] mb-6" data-id="element-98">
          Si eres una mujer de 65 años o más y últimamente:
        </h2>
        <ul className="space-y-4 mb-8" data-id="element-99">
          {['te sientes «un poquito» insegura al caminar en casa,', 'te cuesta pararte de la silla sin usar manos,', 'evitas movimientos simples (girar, retroceder, subir un escalón),', 'o te da miedo caerte (aunque no lo digas),'].map((item, i) => <li key={i} className="flex items-start text-lg md:text-xl" data-id="element-100">
              <span className="h-3 w-3 rounded-full bg-[#2A6B6B] mt-2.5 mr-4 flex-shrink-0" data-id="element-101" />
              <span data-id="element-102">{item}</span>
            </li>)}
        </ul>
        <p className="text-xl font-bold text-[#D4654A]" data-id="element-103">este PDF es para ti.</p>
        <p className="text-lg mt-2 italic text-[#5C544E]" data-id="element-104">
          No para convertirte en atleta. Para sentirte segura.
        </p>
      </motion.section>

      {/* El problema real */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} data-id="element-105">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2A6B6B] mb-6 text-center" data-id="element-106">
          El problema real
        </h2>
        <div className="space-y-6 text-lg md:text-xl leading-relaxed" data-id="element-107">
          <p data-id="element-108">
            La mayoría cree que el problema es la edad. Pero el problema real
            suele ser este:{' '}
            <strong className="text-[#D4654A]" data-id="element-109">
              dejaste de practicar estabilidad.
            </strong>
          </p>
          <p data-id="element-110">Y la estabilidad es como un idioma: si no lo hablas, se oxida.</p>

          <div className="bg-[#E8DDD0]/30 p-6 rounded-xl border-l-4 border-[#D4654A] mt-8" data-id="element-111">
            <div className="space-y-4 font-medium" data-id="element-112">
              <p className="flex items-center" data-id="element-113">
                <span className="w-8 text-[#D4654A] font-bold" data-id="element-114">1.</span>{' '}
                Empiezas a caminar más despacio.
              </p>
              <p className="flex items-center pl-4 border-l-2 border-[#D4654A]/30" data-id="element-115">
                <span className="w-8 text-[#D4654A] font-bold" data-id="element-116">2.</span> Luego
                empiezas a evitar cosas.
              </p>
              <p className="flex items-center pl-4 border-l-2 border-[#D4654A]/30" data-id="element-117">
                <span className="w-8 text-[#D4654A] font-bold" data-id="element-118">3.</span> Luego
                tu cuerpo se vuelve más rígido.
              </p>
              <p className="flex items-center pl-4 border-l-2 border-[#D4654A]/30" data-id="element-119">
                <span className="w-8 text-[#D4654A] font-bold" data-id="element-120">4.</span> Y el
                miedo crece.
              </p>
            </div>
          </div>
        </div>
      </motion.section>

      {/* Por qué lo que probaste no funcionó */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} className="space-y-8" data-id="element-121">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2A6B6B] mb-6" data-id="element-122">
          Por qué lo que probaste no funcionó
        </h2>

        <p className="text-lg md:text-xl" data-id="element-123">
          Caminar ayuda, sí. Pero caminar no entrena lo que más provoca sustos
          en casa:
        </p>

        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-124">
          {['pararte y arrancar con seguridad', 'girar sin perder el centro', 'retroceder sin «pisar mal»', 'mover el peso de un lado al otro sin temblor'].map((item, i) => <li key={i} className="flex items-center bg-[#FFF5F5] p-4 rounded-lg border border-red-100" data-id="element-125">
              <X className="h-6 w-6 text-[#D4654A] mr-3 flex-shrink-0" data-id="element-126" />
              <span className="text-lg" data-id="element-127">{item}</span>
            </li>)}
        </ul>

        <div className="bg-[#F5F5F5] p-6 rounded-xl mt-6" data-id="element-128">
          <p className="font-bold text-lg mb-4" data-id="element-129">
            Los videos genéricos muchas veces:
          </p>
          <ul className="space-y-3" data-id="element-130">
            <li className="flex items-center" data-id="element-131">
              <span className="h-2 w-2 bg-[#5C544E] rounded-full mr-3" data-id="element-132"></span>
              van demasiado rápido
            </li>
            <li className="flex items-center" data-id="element-133">
              <span className="h-2 w-2 bg-[#5C544E] rounded-full mr-3" data-id="element-134"></span>
              usan movimientos que duelen
            </li>
            <li className="flex items-center" data-id="element-135">
              <span className="h-2 w-2 bg-[#5C544E] rounded-full mr-3" data-id="element-136"></span>o
              te hacen sentir que «no puedes»
            </li>
          </ul>
          <p className="mt-6 text-lg font-medium text-[#D4654A]" data-id="element-137">
            Entonces lo dejas. Y vuelves a lo mismo: consejos sueltos, cero
            sistema.
          </p>
        </div>
      </motion.section>
    </div>;
}